import {
  Cancel,
  CheckCircle,
  Pending,
  Schedule,
  Warning,
} from "@mui/icons-material";

// Configuración de estados y prioridades según la API
export const QUOTE_STATUSES = {
  pending: {
    label: "Pendiente",
    color: "warning",
    icon: <Pending />,
    description: "Cotización recién recibida",
  },
  in_progress: {
    label: "En Progreso",
    color: "info",
    icon: <Schedule />,
    description: "Se está procesando la cotización",
  },
  completed: {
    label: "Completada",
    color: "success",
    icon: <CheckCircle />,
    description: "Cotización finalizada exitosamente",
  },
  cancelled: {
    label: "Cancelada",
    color: "error",
    icon: <Cancel />,
    description: "Cotización cancelada",
  },
  rejected: {
    label: "Rechazada",
    color: "error",
    icon: <Warning />,
    description: "Cotización rechazada",
  },
};

export const PRIORITIES = {
  low: { label: "Baja", color: "default", weight: 1 },
  normal: { label: "Normal", color: "primary", weight: 2 },
  high: { label: "Alta", color: "warning", weight: 3 },
  urgent: { label: "Urgente", color: "error", weight: 4 },
};
